import { Grid } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';

export default function DateRangeFilter({
  startDate,
  endDate,
  handleStartDateChange,
  handleEndDateChange,
}) {
  const minDate = dayjs('2000-01-01');
  const maxDate = dayjs().add(1, 'day');

  return (
    <>
      <Grid item xs={12} sm={4} md={2}>
        <DatePicker
          label="Fecha de Inicio"
          value={startDate}
          onChange={handleStartDateChange}
          minDate={minDate}
          maxDate={maxDate}
          sx={{ width: '150px' }}
        />
      </Grid>
      <Grid item xs={12} sm={4} md={2}>
        <DatePicker
          label="Fecha de Fin"
          value={endDate}
          onChange={handleEndDateChange}
          minDate={minDate}
          maxDate={maxDate}
          sx={{ width: '150px' }}
        />
      </Grid>
    </>
  );
}
